import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import './reading-list.css';

export interface ReadingRow {
  /** Short name of what the line reads: "Fréquentation", "Plus forte friction"… */
  label: string;
  content: ReactNode;
  /** The figure the sentence rests on, drawn: a bar, a score, a before → after. */
  visual?: ReactNode;
  /** A Console route, or a full address of the host site (opened in a new tab). */
  action?: { label: string; to: string };
}

const EXTERNAL = /^https?:\/\//;

/**
 * A screen's figures read in plain words, one labelled line per subject: the
 * sentence, the figure it rests on, and the way to the detail.
 */
export function ReadingList({ rows }: { rows: readonly ReadingRow[] }) {
  return (
    <dl className="reading-list">
      {rows.map((row) => (
        <div key={row.label} className="reading-list__row">
          <dt className="reading-list__label">{row.label}</dt>
          <dd className="reading-list__content">{row.content}</dd>
          <dd className="reading-list__visual">{row.visual}</dd>
          <dd className="reading-list__action">
            {row.action &&
              (EXTERNAL.test(row.action.to) ? (
                <a href={row.action.to} target="_blank" rel="noopener noreferrer">
                  {row.action.label} ↗
                </a>
              ) : (
                <Link to={row.action.to}>{row.action.label} →</Link>
              ))}
          </dd>
        </div>
      ))}
    </dl>
  );
}
